export default __webpack_public_path__ + "static/acfxc2-new-airstore-banner-gui-9236fb15331e5d5ab059ff6d7a9db82a.png";